module.exports = __webpack_public_path__ + "on_ramp_sharp_right.svg?30fa12fe2bf23bd3ece8fcf120e4afbc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/on_ramp_sharp_right.svg
// module id = 203
// module chunks = 0